import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { addConditionToDb } from 'store/localDb';
import { getCurrentUserId, addCondition } from 'store/storeValtio';
import moment from 'moment';
import './condition.css';
import { getNowISO } from 'helpers/generalHelpers';

export default function Mood() {
  console.log('Mood');
  const navigate = useNavigate();
  const currentUserId = getCurrentUserId();

  const [submitting, setSubmitting] = useState(false);
  const [moodState, setMoodState] = useState(null);
 
  const moods = [
    {mood: 'Angry', code: ''},
    {mood: 'Anxious', code: ''},
    {mood: 'Apprehensive', code: ''},
    {mood: 'Calm', code: ''},
    {mood: 'Depressed', code: ''},
    {mood: 'Dejected', code: ''},
    {mood: 'Fearful', code: ''},
    {mood: 'Gloomy', code: ''},
    {mood: 'Hopeful', code: ''},
    {mood: 'Irratible', code: ''},
    {mood: 'Nervous', code: ''},
    {mood: 'Ominous', code: ''},
    {mood: 'Overhwhelmed', code: ''},
    {mood: 'Sad', code: ''},
    {mood: 'Strange', code: ''},
  ];

  useEffect(() => {
    const ms = new Array(moods.length).fill(0);
    setMoodState(ms);
  }, [])
  
  function handleMood(e) {
      //console.log('handleMood', e.target.id);
      let ix = parseInt(e.target.id);
      let ms = [...moodState];
      //console.log(ix, ms[ix]);
      ms[ix] = ms[ix] > 0 ? 0 : 1;
      setMoodState(ms);
  }

  const initialValues = {
    userId: currentUserId,
    date: getNowISO(),
    type: 'mood',
    condition: '',
  };


  async function handleSubmit() {
    setSubmitting(true);
    //console.log('submit feelings');

    let m = '';
    for ( let ix=0; ix<moodState.length; ++ix) {
        const ms = moodState[ix];
        const mood = moods[ix].mood;
        //console.log(ix, ms, mood);
        if (ms > 0) m = m + mood + ',';
    }
    //console.log('m', m);

    initialValues.date = getNowISO;
    initialValues.condition = m;
    console.log('addCondition', initialValues);
    await addConditionToDb(initialValues);
    addCondition(initialValues);
    setSubmitting(false);
    navigate('/historyTabs/cond');  // do this to refresh
  }

  //console.log(moodState);

return (
    <div className='mcard'>
      <div className='mcard-header'>What is your mood?</div>
      <div className='mood flex flex-wrap mx-2'>
        <ul className='flex flex-wrap justify-around'>
          {moods.map((m,ix) => {
            return ( 
                <li key={ix}
                  className={`${moodState && moodState[ix] ? 'bg-gray-300' : ''}`}
                  id={ix}
                  onClick={handleMood}
                >
                  {m.mood}
                </li>
            )})
          }
        </ul>
      </div>
      <div className='mcard-title mt-10 justify-center'>
          <button
            className='hpBtn'
            onClick={handleSubmit}
            disabled={submitting}
            type='submit'
          >
            Add Feelings (Mood)
          </button>
        </div>

    </div>
  )
}
